import { z } from 'zod';

// GET /api/v2/agentes/uso — volume, tokens e custo (estimado) por agente/modelo.
// Fonte: conversa_agente (30d). Custo é estimativa (preço por modelo no backend).

export const usoAgenteSchema = z.object({
  agent_id: z.string(),
  nome: z.string(),
  dominio: z.string(),
  conversas_7d: z.coerce.number(),
  conversas_30d: z.coerce.number(),
  tokens_30d: z.coerce.number(),
  custo_30d: z.coerce.number(),
  ultima: z.string().nullable(),
});
export type UsoAgente = z.infer<typeof usoAgenteSchema>;

export const usoModeloSchema = z.object({
  model: z.string(),
  conversas: z.coerce.number(),
  tokens: z.coerce.number(),
  custo: z.coerce.number(),
  pct_custo: z.coerce.number(),
});
export type UsoModelo = z.infer<typeof usoModeloSchema>;

export const usoSchema = z.object({
  gerado_em: z.string().nullable(),
  custo_estimado: z.boolean().default(true),
  totais: z.object({
    conversas_7d: z.coerce.number(),
    conversas_30d: z.coerce.number(),
    tokens_30d: z.coerce.number(),
    custo_30d: z.coerce.number(),
  }),
  agentes: z.array(usoAgenteSchema).default([]),
  modelos: z.array(usoModeloSchema).default([]),
});
export type Uso = z.infer<typeof usoSchema>;
